export const baseUrl = `${process.env.REACT_APP_API_URL}/v1`;
export const geoEndpoint = `https://hunger-hunger.de/geo`;
export const version = process.env.REACT_APP_VERSION;
export const baseUrlV2 = `${process.env.REACT_APP_API_URL}/v2`;
export const restaurantId = window.restaurantId;
export const company = process.env.REACT_APP_COMPANY;
export const isHunger = company === 'hunger-hunger';
